import { DetailCard } from "@hatch-digital-nl/abs-storybook/legacy";
import { format } from "date-fns";
import { ComponentProps } from "react";
import { Dispatch } from "redux";
import React from "react";
import schoolImage from "../../../common/images/school-orange.svg";
import historyImage from "../../../common/images/history.svg";
import infiniteImage from "../../../common/images/infinite.svg";
import achievedImage from "../../../common/images/achieved.svg";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import {
    setIsLeftTagModalOpenIndex,
    setIsRightTagModalOpenIndex,
} from "../ReviewSlice";

type DetailCardMetadataItem = NonNullable<
    ComponentProps<typeof DetailCard>["metadata"]
>[number];

interface Props {
    certificate: CertificateInterface;
    dispatch: Dispatch;
    tagRef: React.RefObject<HTMLDivElement | null>;
    isLeftTagModalOpenIndex: number | null;
    isRightTagModalOpenIndex: number | null;
}

const getDateMetaItems = (
    expiresAt?: string,
    validAt?: string,
): DetailCardMetadataItem[] => {
    const items: DetailCardMetadataItem[] = [
        expiresAt
            ? {
                  type: "label",
                  icon: historyImage,
                  label: `Geldig t/m ${format(expiresAt, "dd-MM-yyyy")}`,
              }
            : {
                  type: "label",
                  icon: infiniteImage,
                  label: "Geen geldigheidsduur",
              },
    ];

    if (validAt) {
        items.push({
            type: "label",
            icon: achievedImage,
            label: `Datum behaald ${format(validAt, "dd-MM-yyyy")}`,
        });
    }

    return items;
};

export const getReviewCardMetadata = (
    props: Props,
): DetailCardMetadataItem[] => {
    const {
        certificate,
        dispatch,
        tagRef,
        isLeftTagModalOpenIndex,
        isRightTagModalOpenIndex,
    } = props;

    const metadata: DetailCardMetadataItem[] = [
        {
            type: "tags",
            tags: certificate.qualification.function_group.map(
                (tag) => tag.name,
            ),
            variant: "primary",
            isOpen: isLeftTagModalOpenIndex === certificate.id,
            onToggle: () =>
                dispatch(setIsLeftTagModalOpenIndex(certificate.id)),
            modalRef: tagRef,
        },
        {
            type: "tags",
            tags: certificate.qualification.qualification_standards.map(
                (tag) => tag.name,
            ),
            variant: "secondary",
            isOpen: isRightTagModalOpenIndex === certificate.id,
            onToggle: () =>
                dispatch(setIsRightTagModalOpenIndex(certificate.id)),
            modalRef: tagRef,
        },
    ];

    metadata.push(
        ...getDateMetaItems(certificate.expires_at, certificate.valid_at),
    );

    if (certificate.educator?.name) {
        metadata.push({
            type: "label",
            icon: schoolImage,
            label: certificate.educator.name,
        });
    }

    return metadata;
};
